import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../../hooks/axios";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { SpecialPrice } from "../../types/specialPrice";
import { formatUkDateTime } from "../../utils/dateUtils";

export default function SpecialPriceDetail() {
  const { id } = useParams();
  const [specialPrice, setSpecialPrice] = useState<SpecialPrice | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchSpecialPriceData();
  }, [id]);

  const fetchSpecialPriceData = async () => {
    try {
      const response = await axiosInstance.get(`/special-prices/${id}`);
      setSpecialPrice(response.data);
    } catch (error) {
      setError("Failed to fetch special price data");
      console.error("Error fetching special price:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string | undefined | null) => {
    if (!dateString) return "-";
    return formatUkDateTime(dateString);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!specialPrice) return <div>No data found</div>;

  return (
    <div className="space-y-6">
      <PageBreadcrumb pageTitle="Special Price Details"  />

      <div className="flex flex-wrap items-center justify-end gap-3">
        <Link
          to={`/special-prices/${id}`}
          className="inline-flex items-center justify-center rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600"
        >
          Edit
        </Link>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-sm dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <dl className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <dt className="text-sm font-medium text-gray-500">From Date</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {formatDate(specialPrice.fromDate)}
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">To Date</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {formatDate(specialPrice.toDate)}
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">Description</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {specialPrice.description}
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">Price Adjustment</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {specialPrice.priceAdjustPers}%
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">Status</dt>
            <dd className="mt-1">
              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                specialPrice.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}>
                {specialPrice.status ? 'Active' : 'Inactive'}
              </span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
} 